module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page video-page manage-page mx-5"
  }, [(_vm.isPageReady) ? _c('content-top-header', [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100"
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: tab.id == _vm.active_tab
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', {
    staticClass: "mr-0"
  }, [_c('v-btn', {
    staticClass: "cancel-btn",
    attrs: {
      "depressed": "",
      "color": "theme--dark red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openStreamDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Stop")])], 1), _vm._v(" "), _c('li', {
    staticClass: "mr-0"
  }, [(_vm.show_view_stream_button) ? _c('v-btn', {
    staticClass: "view-btn",
    attrs: {
      "depressed": "",
      "dark": "",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewStream()
      }
    }
  }, [_vm._v("Watch / Chat")]) : _c('v-btn', {
    staticClass: "px-4 view-btn",
    attrs: {
      "depressed": "",
      "color": "grey lighten-2"
    }
  }, [_vm._v("Connecting...")])], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-right": "-23px"
    }
  }, [_c('v-btn', {
    staticClass: "view-btn",
    attrs: {
      "depressed": "",
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openAddMoreTimeDialog()
      }
    }
  }, [_vm._v("Add Time")])], 1)], 2)])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "app-bold mb-2"
  }, [_vm._v("Setup Live Broadcast")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-info stream-info"
  }, [_c('div', {
    staticClass: "divide"
  }, [_vm._v("\n                Add the "), _c('b', [_vm._v("URL")]), _vm._v(" and "), _c('b', [_vm._v("Stream Key")]), _vm._v(" to your video\n                broadcast Software’s "), _c('b', [_vm._v("Stream Settings")])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("URL: " + _vm._s(_vm.streamUrl)), _c('v-btn', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.streamUrl),
      expression: "streamUrl",
      arg: "copy"
    }],
    staticClass: "clipboard-btn"
  }, [_c('v-icon', [_vm._v("fa-clipboard")])], 1)], 1)]), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n                  Stream Key: " + _vm._s(_vm.streamKey) + "\n                  "), _c('v-btn', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.streamKey),
      expression: "streamKey",
      arg: "copy"
    }],
    staticClass: "clipboard-btn"
  }, [_c('v-icon', [_vm._v("fa-clipboard")])], 1)], 1)])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "app-bold mb-2"
  }, [_vm._v("Analytics")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-info time-info"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Broadcast time")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("timeInHours")(_vm.broadcastSeconds)))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Watching now")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.active_viewers))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Total viewers")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.total_viewers))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Repost")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(0))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Shares")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(0))])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Donations")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(0))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("PPV Sales")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(0))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "custom-lg5"
  }, [_c('label', [_vm._v("Follows")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(0))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', [_vm._v("Attachment Views")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(0))])])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xs": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "app-bold mb-2"
  }, [_vm._v("Broadcast Info")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-info detail-info pa-3 mr-3"
  }, [_c('div', {
    staticClass: "detail-info-top"
  }, [_c('div', {
    staticClass: "mr-3"
  }, [_c('b', [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        _vm.editStreamDetailsActive = true
      }
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), (_vm.stream) ? _c('div', {
    staticClass: "stream-details"
  }, [_c('div', {
    staticClass: "stream-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "stream-info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.stream.name))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [(_vm.stream.genre) ? _c('div', {
    staticClass: "mr-3"
  }, [_c('span', {
    staticClass: "meta-title"
  }, [_vm._v("Genre:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.stream.genre.name))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mr-3"
  }, [_c('span', {
    staticClass: "meta-title"
  }, [_vm._v("Cost:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.stream.view_price))])]), _vm._v(" "), _c('div', {
    staticClass: "mr-3"
  }, [_c('span', {
    staticClass: "meta-title"
  }, [_vm._v("Capacity:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.stream.viewers_limit))])])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.stream.description))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "divide"
  }), _vm._v(" "), _c('div', {
    staticClass: "feature-info"
  }, [_c('div', {
    staticClass: "feature-info-top"
  }, [_c('div', {
    staticClass: "mr-3"
  }, [_c('b', [_vm._v("Feature Profiles")])]), _vm._v(" "), _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        _vm.add_account_active = true
      }
    }
  }, [_vm._v("Add Profile")])]), _vm._v(" "), _c('div', {
    staticClass: "featured-users"
  }, [(_vm.featuredUsers) ? _c('div', _vm._l((_vm.featuredUsers), function(u, i) {
    return _c('v-chip', {
      key: i
    }, [_c('span', {
      staticClass: "remove-acc",
      on: {
        "click": function($event) {
          _vm.removeAccount(u)
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "color": "white"
      }
    }, [_vm._v("close")]), _vm._v(" "), _c('span', [_vm._v("Remove")])], 1), _vm._v(" "), _c('user-tag', {
      staticClass: "tag",
      attrs: {
        "showAvatar": "",
        "clickUser": false,
        "user": u
      }
    })], 1)
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "divide"
  }), _vm._v(" "), _c('div', {
    staticClass: "attachment-details"
  }, [_c('div', {
    staticClass: "attachment-info-top"
  }, [_c('div', {
    staticClass: "mr-3"
  }, [_c('b', [_vm._v("Attachment")])]), _vm._v(" "), (_vm.assoc) ? _c('div', {
    staticClass: "cursor-pointer mr-3",
    on: {
      "click": _vm.changeStreamAttach
    }
  }, [_vm._v("Change")]) : _vm._e(), _vm._v(" "), (_vm.assoc) ? _c('div', {
    staticClass: "cursor-pointer red--text",
    on: {
      "click": _vm.removeStreamAttach
    }
  }, [_vm._v("Remove")]) : _vm._e(), _vm._v(" "), (!_vm.assoc) ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.addStreamAttach
    }
  }, [_vm._v("Add")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dflex"
  }, [_c('attach', {
    ref: "streamAttach",
    staticClass: "mr-3",
    attrs: {
      "hideMetaActions": ""
    },
    on: {
      "input": function($event) {
        _vm.saveAttach()
      }
    },
    model: {
      value: (_vm.stream_assoc),
      callback: function($$v) {
        _vm.stream_assoc = $$v
      },
      expression: "stream_assoc"
    }
  }), _vm._v(" "), (_vm.stream) ? _c('div', {
    staticClass: "attachment-info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.stream_assoc.name))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "mr-3"
  }, [(_vm.stream.assoc_type === 'Album') ? _c('span', {
    staticClass: "meta-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.stream_assoc.tracks.length) + " " + _vm._s(("" + (_vm.stream_assoc.tracks.length > 1 ? 'Tracks' : 'Track'))) + "\n                      ")]) : _vm._e()])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "divide"
  }), _vm._v(" "), _c('div', {
    staticClass: "share-social-info"
  }, [_c('div', {
    staticClass: "share-social-info-top"
  }, [_c('div', {
    staticClass: "mr-3"
  }, [_c('b', [_vm._v("Share")])])]), _vm._v(" "), _c('div', {
    staticClass: "dflex"
  }, [_c('social-sharing', {
    attrs: {
      "title": ((_vm.currentUser.username) + " is Broadcasting Live!"),
      "url": _vm.profileUrl
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "share-social-section"
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('v-btn', {
            staticClass: "social-share-btn",
            attrs: {
              "depressed": ""
            }
          }, [_c('v-icon', [_vm._v("fa-facebook")])], 1)], 1), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('v-btn', {
            staticClass: "social-share-btn"
          }, [_c('v-icon', [_vm._v("fa-twitter")])], 1)], 1)], 1)
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-section"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileUrl),
      expression: "profileUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.profileUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profileUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.profileUrl),
      expression: "profileUrl",
      arg: "copy"
    }],
    staticClass: "clipboard-btn"
  }, [_c('v-icon', [_vm._v("fa-clipboard")])], 1)], 1)], 1)])])])])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_stream_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_stream_delete_confirm_dialog = $$v
      },
      expression: "show_stream_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Stream")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the stream will no longer be available. Click OK\n            to delete, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteStream()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeStreamDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_create_failed_dialog),
      callback: function($$v) {
        _vm.show_create_failed_dialog = $$v
      },
      expression: "show_create_failed_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Failed in Creating a Stream")]), _vm._v(" "), _c('v-card-text', [_vm._v("Channel failed to start, you have not been charged. Please try\n            again.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeCreateFailedDialog()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    directives: [{
      name: "on-click-outside",
      rawName: "v-on-click-outside",
      value: (_vm.closeAddMoreTimeDialog),
      expression: "closeAddMoreTimeDialog"
    }],
    attrs: {
      "content-class": "add-more-time-dialog"
    },
    model: {
      value: (_vm.show_add_more_time_dialog),
      callback: function($$v) {
        _vm.show_add_more_time_dialog = $$v
      },
      expression: "show_add_more_time_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Add more time to your broadcast")]), _vm._v(" "), _c('v-card-text', [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.costs,
      "item-text": "name",
      "item-value": "value"
    },
    model: {
      value: (_vm.streamCost),
      callback: function($$v) {
        _vm.streamCost = $$v
      },
      expression: "streamCost"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openPaymentDialog()
      }
    }
  }, [_vm._v("Add More Time")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "add-more-time-caution-dialog"
    },
    model: {
      value: (_vm.show_add_more_time_caution_dialog),
      callback: function($$v) {
        _vm.show_add_more_time_caution_dialog = $$v
      },
      expression: "show_add_more_time_caution_dialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-card-text', [_vm._v("\n            You have about"), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.remainingTime))]), _c('br'), _vm._v("\n            remaining before your broadcast ends."), _c('br'), _vm._v("\n            Add more time to continue broadcasting.\n          ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeAddMoreTimeCautionDialog()
      }
    }
  }, [_vm._v("\n              Close")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "edit-stream-details-dialog"
    },
    model: {
      value: (_vm.edit_stream_details_active),
      callback: function($$v) {
        _vm.edit_stream_details_active = $$v
      },
      expression: "edit_stream_details_active"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Pay Per View?")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.view_prices,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.view_price),
      callback: function($$v) {
        _vm.$set(_vm.stream, "view_price", $$v)
      },
      expression: "stream.view_price"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Event Capacity")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.viewers_limits,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.viewers_limit),
      callback: function($$v) {
        _vm.$set(_vm.stream, "viewers_limit", $$v)
      },
      expression: "stream.viewers_limit"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Description"), _c('span', {
    staticClass: "ml-1 meta-annotate"
  }, [_vm._v("160 char max")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stream.description),
      expression: "stream.description"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "160"
    },
    domProps: {
      "value": (_vm.stream.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.stream, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Thumbnail")]), _vm._v(" "), _c('div', {
    staticClass: "video-thumbnail-container"
  }, [_c('div', {
    staticClass: "video-thumbnail-wrapper"
  }, [(_vm.stream_cover_url) ? _c('div', {
    staticClass: "video-thumbnail",
    style: ({
      'background-image': 'url(' + _vm.stream.cover.thumb.url || _vm.stream.cover + ')',
    })
  }) : _c('div', {
    staticClass: "video-thumbnail"
  })]), _vm._v(" "), _c('div', {
    staticClass: "cover-wrapper"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "file",
      "name": "stream_cover_file",
      "id": "stream_cover_file",
      "accept": ".png, .jpg, .jpeg"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "stream_cover_file"
    }
  }, [_vm._v("Upload")]), _vm._v(" "), _c('span', {
    staticClass: "meta-annotate"
  }, [_vm._v("*PNG, JPG, GIF")])])])])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('div', {
    staticClass: "text-center width100"
  }, [_c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue",
      "loading": _vm.saveDetailsLoader
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveStreamDetails()
      }
    }
  }, [_vm._v("Save")])], 1)])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "add-users-dialog"
    },
    model: {
      value: (_vm.add_account_active),
      callback: function($$v) {
        _vm.add_account_active = $$v
      },
      expression: "add_account_active"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-card-text', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_user),
      expression: "search_user"
    }],
    staticClass: "width100 mb-3 pa-2",
    attrs: {
      "type": "text",
      "placeholder": "Search User"
    },
    domProps: {
      "value": (_vm.search_user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_user = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search_user-results featured-users"
  }, _vm._l((_vm.users), function(u, i) {
    return _c('v-chip', {
      key: i
    }, [_c('span', {
      staticClass: "add-acc __acc",
      on: {
        "click": function($event) {
          _vm.addAccount(u)
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "color": "white"
      }
    }, [_vm._v("add")])], 1), _vm._v(" "), _c('user-tag', {
      staticClass: "tag",
      attrs: {
        "showAvatar": "",
        "clickUser": false,
        "user": u
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "px-4 mt-3",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue",
      "loading": _vm.searchUserLoader
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateUsersList()
      }
    }
  }, [_vm._v("Add")])], 1)])], 1)], 1), _vm._v(" "), (_vm.show_payment_dialog) ? _c('payment-modal', {
    attrs: {
      "amount": _vm.streamCost,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.deposit
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d1173a4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/manage.vue
// module id = 1764
// module chunks = 180